import jQuery from 'jquery';
import * as Popper from "@popperjs/core"
import Modal from 'bootstrap';

var Flickity = require('flickity');
require('flickity-imagesloaded');

import {settings} from './variables.js';

var baseUrl = settings.apiBaseUrl;

const exampleModal = document.getElementById('mainModal')
exampleModal.addEventListener('show.bs.modal', event => {
  
  const button = event.relatedTarget
  
  const mTtile = button.getAttribute('data-bs-mtitle')
  
  if (mTtile) {
    const modalTitle = exampleModal.querySelector('.modal-title')
    modalTitle.textContent = mTtile
  }

  const mText = button.getAttribute('data-bs-mtext')
  
  if (mText) {
    const modalAnons = exampleModal.querySelector('.modal-anons')
    modalAnons.textContent = mText
  }
  
})


jQuery('.toggle-btn').click(function () {
    jQuery('.hide-collapse').not(jQuery(jQuery(this).attr('data-toggle'))).removeClass('show-collapse');
    jQuery(jQuery(this).attr('data-toggle')).toggleClass('show-collapse');
});

jQuery(document).ready(function() {

    jQuery('.faq__answer').hide();
    jQuery('.faq__question-toggle').click(function() {
        jQuery(this).parent().toggleClass('faq__question--open');
        jQuery(this).parent().parent().find('.faq__answer').toggle(300);
    });

});

if (jQuery('.product-images').length) {
    var flkty = new Flickity( '.product-images', {
        imagesLoaded: true,
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        wrapAround: true
    });
}